import { clearAssistantCache } from '@/components/code-editor/assistant-history'
import { disconnectSockets } from '@/composables/useSocketIo'
import { TABS_KEY, TEAM_MEMBERS_KEY } from '@/data/constants'
import { useBillingStore } from '@/stores/billing.store'
import { useCollaborationPresenceStore } from '@/stores/collaboration-presence.store'
import { useDownloadsStore } from '@/stores/downloads.store'
import { useMenuStore } from '@/stores/menu.store'
import { useSchemaStore } from '@/stores/schema.store'
import { useSettingsStore } from '@/stores/settings.store'
import { useTabsStore } from '@/stores/tabs.store'
import { useTeamStore } from '@/stores/team.store'
import { useVersionsStore } from '@/stores/versions.store'

export function resetAccountState() {
    disconnectSockets()
    clearAssistantCache(localStorage)
    localStorage.removeItem(TABS_KEY)
    localStorage.removeItem(TEAM_MEMBERS_KEY)
    useTabsStore().resetAccountState()
    for (const useStore of [useSchemaStore, useBillingStore, useTeamStore, useDownloadsStore,
        useVersionsStore, useCollaborationPresenceStore, useMenuStore]) {
        useStore().$reset()
    }
    const settings = useSettingsStore()
    settings.showModal = false
    settings.modals.history = false
}
